module.exports = __webpack_public_path__ + "img/icn-callout-1.3397d3e.3397d3e4.svg";